module.exports = __webpack_public_path__ + "images/rbk-colored-4a4e63.svg";